
export default class PlanList  {

    constructor () {


        this.onLoad()
        this.events()
    }

    events() {
        $('#plan-list-card').on('click', 'a.select-plans-button', e => this.pickPlanBtn_Click(e))
    }


    onLoad() {

    }

    pickPlanBtn_Click(e) {
        e.preventDefault()

        if(!logged_user_id.length) {
            $('#register-form').prepend(`
                    <input type="hidden" name="redirect_uri" value="${$(e.currentTarget).attr('href')}">
            `)
            $('#login-form').prepend(`
                <input type="hidden" name="redirect_uri" value="${$(e.currentTarget).attr('href')}">
            `)
            if(user_id_cookie.length) {
                $('#signinModal').modal()
                return
            } else {
                $('#signupModal').modal()
                return
            }
        }

        window.location.assign($(e.currentTarget).attr('href'))
    }

}
